import { TopNav } from '../topnav';

export default TopNav;
